import React, { useEffect } from "react";
import BusinessTag from "components/1tyons/BusinessTag";
import ArrowIcon from "assets/icons/tryons/ArrowIcon";

const EarlyAccess = () => {
  const steps = [
    {
      id: 1,
      title: "Upload Garment",
    },
    {
      id: 2,
      title: "Select Models",
    },
    {
      id: 3,
      title: "Download and Share",
    },
  ];

  useEffect(() => {
    const widgetScriptSrc = "https://tally.so/widgets/embed.js";

    const load = () => {
      // Load Tally embeds
      //@ts-ignore
      if (typeof Tally !== "undefined") {
        //@ts-ignore
        Tally.loadEmbeds();
        return;
      }

      // Fallback if window.Tally is not available
      //@ts-ignore
      document
        .querySelectorAll("iframe[data-tally-src]:not([src])")
        .forEach((iframeEl) => {
          //@ts-ignore
          iframeEl.src = iframeEl.dataset.tallySrc;
        });
    };

    // If Tally is already loaded, load the embeds
    //@ts-ignore
    if (typeof Tally !== "undefined") {
      load();
      return;
    }

    // If the Tally widget script is not loaded yet, load it
    if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
      const script = document.createElement("script");
      script.src = widgetScriptSrc;
      script.onload = load;
      script.onerror = load;
      document.body.appendChild(script);
      return;
    }
  }, []);

  return (
    <div className="flex h-[100vh]">
      <div className="w-[55%] h-[100%]">
        <div className="flex flex-col items-center h-full justify-center gap-2 w-[70%] mx-auto">
          <p className="text-[1.8rem] text-white text-center font-semibold">
            Transform Your Fashion Experience
          </p>
          <p className="text-[1.5rem] text-[#B3B3B3] text-center font-medium">
            Upload your garments and see them come to life on your chosen models
            with the power of AI.
          </p>
          <div className="flex items-center text-[#fff] gap-2 w-full mt-4">
            {steps.map((step) => (
              <div className="flex items-center gap-2 w-full">
                <div className="flex items-center flex-col justify-between gap-2 w-full">
                  <span className="border-white text-[0.8rem] font-bold border-2 rounded-full w-[28px] h-[28px] flex items-center justify-center">
                    {step.id}
                  </span>
                  <p className="text-[1.125rem] font-medium text-center">
                    {step.title}
                  </p>
                </div>
                {step.id !== steps.length && <ArrowIcon />}
              </div>
            ))}
          </div>
          <video
            src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
            className="w-full aspect-video bg-[#757575] rounded-xl mt-4"
            // autoPlay
            controls
            muted
            loop
          />
        </div>
      </div>
      <div className="bg-[#1e1e1e] w-[45%] h-[100%] px-[2rem] py-[6rem] flex flex-col justify-between items-center">
        <div className="flex items-center gap-1.5 mb-[1.5rem]">
          <h3
            style={{ textShadow: "2px 4px 15px rgba(14,216,226,0.79)" }}
            className="text-[3rem] font-semibold  text-turquoise text-center "
          >
            tryons
          </h3>
        </div>
        <div className="flex flex-col items-center gap-2 w-[90%] 2xl:w-[70%]">
          <p className="text-[1.8rem] text-white text-center mb-[0.7rem] font-semibold">
            Be the First to Try Virtual Fashion!
          </p>
          <p className="text-[1.125rem] text-[#B3B3B3] text-center font-medium">
            Join our Early Access Program and Experience the Future of Online
            Shopping.
          </p>
          <div className="flex items-center gap-2 w-full">
            <iframe
              data-tally-src="https://tally.so/r/wd2Ngz"
              loading="lazy"
              width="100%"
              height="421"
              title="Provassure"
            ></iframe>
          </div>
        </div>
        <div>
          <p className="text-[1.125rem] text-[#B3B3B3] text-center font-medium w-[90%] 2xl:w-[70%] mx-auto">
            You’ll be among the first to access exclusive features and provide
            valuable feedback to shape the future of Tryons.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EarlyAccess;
